<template>
  <div>
    <a-card style="margin-top:20px;">
      <!--新增 | 维护 MODAL-->
      <create-form ref="createModal" @getTableList="_getTableData" />
      <!-- 结果 -->
      <div class="text-right">
        <a-button
          @click="_exportAssurance"
          type="primary"
          class="margin-right-20"
        >
          导出excel
        </a-button>
        <a-button @click="$refs.createModal.add()" type="primary" icon="plus">
          新增记录
        </a-button>
      </div>
      <TableView
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :loading="loading"
        :scroll="scroll"
        @handlePagination="handlePagination"
      >
        <!--类型 slot-->
        <template v-slot:type="{ tableRow }">
          <span>{{ TYPE_NAME_OBJ[tableRow.type] }}</span>
        </template>
        <!--货币单位 slot-->
        <template v-slot:currencyUnit="{ tableRow }">
          <span>{{ tableRow.currencyUnit === 1 ? 'RMB' : 'USD' }}</span>
        </template>
        <!--担保金额(元) slot-->
        <template v-slot:amount="{ tableRow }">
          <span>{{ tableRow.amount | formatAmount }}</span>
        </template>
        <!--操作 slot-->
        <template v-slot:action="{ tableRow }">
          <a
            href="javascript:void(0)"
            @click="_downloadAssurance(tableRow.id)"
            :disabled="tableRow.url == '' ? true : false"
          >
            下载
          </a>
          <a-divider type="vertical" />
          <a-upload
            name="file"
            :multiple="false"
            action="/credit/insurance/upload"
            :show-upload-list="false"
            :data="{
              id: tableRow.id,
            }"
            :headers="{ token }"
            @change="uploadChange"
          >
            <a href="javascript:void(0)">
              上传
            </a>
          </a-upload>
          <a-divider type="vertical" />
          <a
            href="javascript:void(0)"
            @click="$refs.createModal.edit(tableRow)"
          >
            编辑
          </a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除吗?"
            @confirm="() => handleDel(tableRow.id)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a href="javascript:void(0)" size="small">
              删除
            </a>
          </a-popconfirm>
        </template>
      </TableView>
    </a-card>
  </div>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import CreateForm from './components/CreateForm'
import {
  getAssurance,
  downloadAssurance,
  deleteAssurance,
  exportAssurance,
} from './api'
import { mapGetters } from 'vuex'
import { LOGIN_EXPIRED } from 'config/index'
import storage from 'good-storage'
import mixin from './mixin'
export default {
  mixins: [mixin],
  components: {
    TableView,
    CreateForm,
  },
  computed: {
    ...mapGetters('app', ['company']),
    ...mapGetters('user', ['token']),
  },
  data() {
    return {
      loading: '',
      scroll: { x: 1500 }, //滚动设置
      formLayout: 'horizontal',
      tableData: [],
      pageData: {
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      url: '',
      companyId: this.$route.params.id,
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    //获取table数据
    async _getTableData() {
      this.loading = true
      const { current, pageSize } = this.pageData
      const query = {
        companyId: this.companyId,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getAssurance(query)

        this.tableData = records
        this.pageData.total = total
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch(query) {
      this.searchData.name = query.name
      this.searchData.username = query.username
      this.searchData.status = query.status
      this._getTableData()
    },
    //分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)

      this._getTableData()
    },
    showModal() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    //抵押和担保下载
    _downloadAssurance(id) {
      try {
        downloadAssurance(id)
      } catch (err) {
        console.log(err)
      }
    },
    //抵押和担保上传
    uploadChange(data) {
      const {
        file: { response },
      } = data
      if (response && response.code === '0000') {
        this.$message.success('成功')
        this._getTableData()
      } else {
        if (response && response.code == LOGIN_EXPIRED) {
          // 此时登录过期
          this.$message.error('登录过期，请重新登录')
          window.setTimeout(() => {
            storage.clear()
            this.$router.push('/login')
          }, 1000)
        }
      }
    },
    async handleDel(id) {
      try {
        await deleteAssurance(id)
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
    //抵押和担保导出excel
    _exportAssurance() {
      try {
        exportAssurance(this.$route.params.id)
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
